export const grillroom = {
  hero: {
    title: 'How Grillroom Istanbul finally found real trust in an online partner',
    description: 'A great example is "Istanbul Grillrestaurant," a popular grillroom located in the lively center of Valkenswaard.'
  },
  testimonials: {
    1: {
      text: 'With Bistroo, we save more than 250 euros per month. Thanks to promotion, we also saw more customers coming in through Bistroo. This is great for us since the costs for these orders are much lower.',
      name: 'Hamza',
      job_title: 'Owner'
    },
    2: {
      text: 'With Bistroo, we experience a much better collaboration than we were used to. Not such a distant system like others parties. Plus, we have a lot more control with the manager app. This gives a trustworthy feeling.',
      name: 'Hamza',
      job_title: 'Owner'
    }
  },
  challenge: {
    paragraph: {
      title: 'Finally an honest revenue model',
      text: 'The restaurant is run by Hamza, who has been with Bistroo for just over a year. Previously, Istanbul Grillrestaurant mainly relied on other ordering solutions that charged high commission fees, leading to higher costs and lower margins.'
    },
    paragraph_2: {
      title: 'The challenge',
      bullets: {
        1: 'Hamza aimed to minimize operational costs while improving efficiency.',
        2: 'Istanbul Grillrestaurant wanted to recover its investment in the restaurant as quickly as possible.',
        3: 'Looking for a reliable partner with a transparent revenue model',
        4: ''
      }
    }
  },
  solution: {
    title: 'The solution',
    checklist: {
      1: 'Bistroo provided Istanbul Grillrestaurant with a website and took care of their Google My Business setup, making it easy for customers to place pickup and delivery orders online.',
      2: 'With Bistroo, Istanbul Grillrestaurant quickly began saving around €250 per month. Thanks to promotional support, Hamza noticed more and more customers ordering via Bistroo — great news, especially at the start of his entrepreneurial journey, since Bistroo charges significantly lower commissions. Now, a year later, he’s saving an average of €240–€250 per month — a nice amount to reinvest or use to hire an extra delivery driver.      ',
      3: 'Through the dashboard, Hamza gains insights into his customer base. He can clearly see who his top customers are and in which regions he has the most clientele.',
      4: 'With Bistroo, Hamza feels like he’s working with real people rather than a distant system. Compared to other platforms where he signed up without meeting anyone and had to install everything himself, Bistroo offers a personal touch. There is direct contact with someone at Bistroo, resulting in excellent customer service and easy accessibility.',
      5: 'Thanks to Bistroo’s online ordering solution, Istanbul Grillrestaurant had a clear overview of all orders, reducing mistakes and misunderstandings while making the kitchen more efficient.',
      6: 'With Bistroo, Istanbul Grillrestaurant could better manage its own peak times and busy periods, improving customer experience and maximizing revenue.'
    }
  },
  conclusion: {
    title: 'The conclusion',
    text: {
      1: 'Bistroo’s online ordering solution provided Istanbul Grillrestaurant with an effective way to address these challenges and streamline operations. Bistroo came at just the right time, offering a fair revenue model compared to other major players in the market. More and more customers — both regulars and new ones — are now coming to Istanbul Grillrestaurant via Bistroo. Bistroo supported them during the launch with a flyer campaign, branded bags, and stickers.      ',
      2: 'With Bistroo, Hamza feels like he’s collaborating with people instead of interacting with a distant system. Unlike other ordering parties/platforms where he signed up without seeing anyone and had to install everything himself, Bistroo offers a personal approach. There is direct contact with someone from Bistroo, resulting in great customer service and easy accessibility.'
    }
  }
}